import { createPortal } from 'react-dom'
import { useState } from 'react'
import {
  SERVICE_BANNER,
  TERMS_AND_CONDITIONS_BANNER
} from 'constants/feature-flags'
import CookiePolicy from 'components/layout/Banners/CookiePolicy'
import TermsAndConditionsBanner from 'components/layout/Banners/TermsAndConditionsBanner'
import ServiceUnavailableBanner from 'components/layout/Banners/ServiceUnavailableBanner'

export default function Banners (): JSX.Element {
  const [cookieDismissed, setCookieDismissed] = useState(false)
  const [termsDismissed, setTermsDismissed] = useState(false)

  // Portalled to document.body so Headless UI's inert mechanism (applied to #root when a Dialog opens) cannot block banner interaction.
  return createPortal(
    <>
      {SERVICE_BANNER && <ServiceUnavailableBanner />}
      {TERMS_AND_CONDITIONS_BANNER && (
        <TermsAndConditionsBanner dismissed={termsDismissed} setDismissed={setTermsDismissed} offset={!cookieDismissed} />
      )}
      <CookiePolicy dismissed={cookieDismissed} setDismissed={setCookieDismissed} />
    </>,
    document.body
  )
}
